export default {
  STARTING: "starting",
  STARTED: "started",
  FAILURE: "failure",
  CONNECTION_LOST: "connectionLost",
  SIGNING_OUT: "signingOut",
  INACTIVE_MODE: "inactiveMode",
  ALREADY_OPEN: "alreadyOpen"
};
